import { LogoZiggo } from 'assets/img/Logo';
import ErrorImage from 'assets/img/ZiggoCustomerErrorCat.svg';
import { BaseLayoutContext } from 'components/BaseLayout/BaseLayout';
import React, { useContext } from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './error.content';
import * as S from './error.styles';

const contentUtil = new ContentUtil({ content, componentName: 'Error' });

export const Error = () => {
  const baseLayoutContext = useContext(BaseLayoutContext);
  baseLayoutContext.setShowHeaderAndFooter(false);

  return (
    <S.Error>
      <S.ErrorHeader>
        <LogoZiggo width="104" height="36" />
      </S.ErrorHeader>
      <S.ErrorContent>
        <S.Img>
          <img src={ErrorImage} alt="error" />
        </S.Img>
        <S.Message>
          <h1>{contentUtil.translateToString('header')}</h1>
          <h2>{contentUtil.translateToString('text')}</h2>
          <S.Button as="a" onClick={() => window.location.reload()}>
            {contentUtil.translateToString('refresh')}
          </S.Button>
        </S.Message>
      </S.ErrorContent>
      <S.ErrorFooter>
        <S.Support>
          <b>{contentUtil.translateToString('supportHeader')}</b>
          <S.SupportLinks>
            <a href={contentUtil.translateToString('supportLinks.klantenservice.url')}>
              {contentUtil.translateToString('supportLinks.klantenservice.text')}
            </a>
            <a href={contentUtil.translateToString('supportLinks.storingschecker.url')}>
              {contentUtil.translateToString('supportLinks.storingschecker.text')}
            </a>
            <a href={contentUtil.translateToString('supportLinks.community.url')}>
              {contentUtil.translateToString('supportLinks.community.text')}
            </a>
          </S.SupportLinks>
        </S.Support>
      </S.ErrorFooter>
    </S.Error>
  );
};
